/* eslint-disable */
import React, {useMemo} from "react";
import styles from "./Header.module.css";
import NavButton from "../../../../common/components/button/NavButton";
import {HeaderLogo} from "./HeaderLogo";
import {useSelector} from "react-redux";
import {AppState} from "src/root/RootReducer";
import PresenterIcon from "./assets/PresenterIcon.svg";
import userProfile from "../../../../assets/icon/userProfile.jpeg";
import ProgramIcon from "./assets/ProgramIcon.svg";
import VideoIcon from "./assets/VideoIcon.svg";

import SearchIcon from "@material-ui/icons/Search";
import {
    Avatar,
    createStyles,
    makeStyles,
    Theme
} from "@material-ui/core";
import Modal from "@material-ui/core/Modal";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";

import UserApi from "../../../../user/UserApi";
import EditAdminPage from "../../../../admin/viewer/EditAdminPage";
import Typography from "@material-ui/core/Typography";
import OnLeaveDialog from "../../../../common/components/dialog/OnLeaveDialog";
import EditProfileImage from "../../../../common/components/modal/EditProfileImage";
import { isAdmin,isPresenter } from "../../../../utils/LogicUtils";
import PuiTooltip from "../../../../components/elements/PuiTooltip ";
import HomesIcon from "./assets/home.svg";
import useResponsive from "../../../../common/useResponsive";
import {useNavigate} from "react-router-dom";
import userService from "src/utils/UserService";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        profile: {
            width: theme.spacing(7),
            height: theme.spacing(7),
            marginLeft: "10px",
            cursor: "pointer",
            backgroundColor: "white"
        },
        mobileProfile: {
            width: theme.spacing(4),
            height: theme.spacing(4),
            marginLeft: "10px",
            cursor: "pointer",
            backgroundColor: "white"
        },
        divider: {
            width: "2px"
        },
        avatar: {
            marginLeft: "70px",
            marginBottom: "10px",
            width: "80px",
            height: "80px",
            cursor: "pointer",
            backgroundColor: "white"
        },
        icon: {
            fontSize: "30px",
            color: "var(--red)"
        }
    })
);

function Header() {
    const classes = useStyles();

    const {userInfo} = useSelector((state: AppState) => ({
        userInfo: state.user.userInfo
    }));

    const {isDesktop, isMobile} = useResponsive();

    // const {instance} = useMsal();

    //モーダル画面
    // const [modalStyle] = React.useState(getModalStyle);
    const [isOpenUserInfoModal, ShowUserInfoModal] = React.useState(false);
    const [isOpenAdminModal, ShowUserAdminModal] = React.useState(false);
    const [isSaved, setIsSaved] = React.useState<boolean>(true);
    const [openDialog, setOpenDialog] = React.useState(false);

    const OpenUserInfoModal = () => {
        ShowUserInfoModal(true);
    };

    const CloseUserInfoModal = () => {
        ShowUserInfoModal(false);
    };

    const OpenAdminModal = () => {
        CloseUserInfoModal();
        ShowUserAdminModal(true);
    };

    const CloseAdminModal = () => {
        if (isSaved) {
            ShowUserInfoModal(false);
            ShowUserAdminModal(false);
        } else {
            setOpenDialog(true);
        }
    };
    const navigate = useNavigate();
    // ロクアウト
    const Logout = () => {
        UserApi.Logout().finally(() => {
            navigate("/login");
            userService.clear();
        });
    };


    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const handleCancel = () => {
        handleCloseDialog();
    };

    const handleConfirm = () => {
        setIsSaved(true);
        ShowUserInfoModal(false);
        ShowUserAdminModal(false);
        handleCloseDialog();
    };

    const getNavBtnComp = () => {
        return (
            <>
                <div>
                    <NavButton
                        color="white"
                        path="/homepage"
                        icon={
                            <img
                                alt="HomesIcon"
                                className={classes.icon}
                                src={HomesIcon}
                                height="18px"
                                width="18px"
                            />
                        }
                    >
            Home
                    </NavButton>
                </div>

                {/* プロフェッショナル */}
                <div>
                    <NavButton
                        color="white"
                        path="/presenter"
                        icon={
                            <img
                                alt="PresenterIcon"
                                className={classes.icon}
                                src={PresenterIcon}
                                height="18px"
                                width="18px"
                            />
                        }
                    >
            Presenter
                    </NavButton>
                </div>

                <div>
                    <NavButton
                        color="white"
                        path="/channels"
                        icon={
                            <img
                                alt="ProgramIcon"
                                className={classes.icon}
                                src={ProgramIcon}
                                height="18px"
                                width="18px"
                            />
                        }
                    >
            Channel
                    </NavButton>
                </div>

                <div>
                    <NavButton
                        color="white"
                        path="/videos"
                        icon={
                            <img
                                alt="VideoIcon"
                                className={classes.icon}
                                src={VideoIcon}
                                height="18px"
                                width="18px"
                            />
                        }
                    >
            Video
                    </NavButton>
                </div>
            </>
        );
    };

    const getSearchAndAvatarComp = () => {
        return (
            <div className={styles.searchAndAvatar}>
                {/* サーチ */}
                <div className={`${styles.buttonSearch}`} style={{width: "115px"}}>
                    <NavButton
                        color="white"
                        path="/search"
                        icon={<SearchIcon color="primary"/>}
                    >
          Search
        </NavButton>
      </div>
      {
        userInfo?.imageUrl ? (
          <Avatar
            alt="ForDev"
            className={isMobile ? classes.mobileProfile : classes.profile}
            src={userInfo?.imageUrl.includes("User_NoImage") ? userProfile : userInfo?.imageUrl}
            onClick={OpenUserInfoModal}
          />
        ) : !userInfo ?(
          <a href="/login" className={styles.loginLink}>
            <Avatar
              alt="ForDev"
              className={isMobile ? classes.mobileProfile : classes.profile}
              src={userProfile}
              onClick={OpenUserInfoModal}
            />
          </a>
        ) : (<Avatar
          alt="ForDev"
          className={isMobile ? classes.mobileProfile : classes.profile}
          src={userProfile}
          onClick={OpenUserInfoModal}
        />)
      }
    </div>)
  }

  const hasAuthRoleKey = useMemo(() => {
    if (isAdmin(userInfo?.roles)) {
      return 'admin'
    }
    if (isPresenter(userInfo?.roles)) {
      return 'presenter'
    }
    return undefined
  },[userInfo?.roles])

  const getUserInfoAndManageComp = () => {
    return (<>
      {/* ユーザ情報表示モーダル */}
                      {/* ユーザ情報表示モーダル */}
                <Modal
                    open={isOpenUserInfoModal}
                    onClose={CloseUserInfoModal}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                >
                    <>
                        <Card className={styles.userInfoModal}>
                            <CardContent
                                className={styles.userInfoModalItem}
                                style={{marginBottom: "10px", display: "block"}}
                            >
                                {userInfo?.imageUrl ? (
                                    <Avatar
                                        src={
                                            userInfo?.imageUrl.includes("User_NoImage") ?
                                                userProfile : userInfo?.imageUrl
                                        }
                                        className={classes.avatar}
                                    ></Avatar>
                                ) : (
                                    <Avatar className={classes.avatar}></Avatar>
                                )}
                                <EditProfileImage
                                    userid={userInfo?.id}
                                    fullname={userInfo?.fullName}
                                    organization={userInfo?.organization}
                                    localAccountId={userInfo?.localAccountId}
                                    onClose={CloseUserInfoModal}
                                />
                                <Typography
                                    variant="h6"
                                    component="p"
                                    className={styles.string}
                                >
                                    {userInfo?.fullName}
                                </Typography>
                                <Typography
                                    data-tip={userInfo?.email}
                                    data-for="email"
                                    variant="body2"
                                    className={styles.string}
                                    style={{color: "gray"}}
                                >
                                    {userInfo?.email}
                                </Typography>
                            </CardContent>
                            <CardActions style={{display: "block", padding: "0 auto"}}>
                                {isDesktop && hasAuthRoleKey &&   (
                                    <Button
                                        size="small"
                                        variant="outlined"
                                        style={{
                                            marginTop: "-15px",
                                            marginLeft: "55px",
                                            display: "block",
                                            marginBottom: "15px",
                                            width: "130px"
                                        }}
                                        onClick={OpenAdminModal}
                                    >
                  管理
                                    </Button>
                                )}
                                {/* <Button
                        size="small"
                        variant="outlined"
                        style={{
                          marginTop: "-15px",
                          marginLeft: "55px",
                          display: "block",
                          marginBottom: "15px",
                          width: "130px",
                        }}
                        onClick={OpenAdminModal}
                      >
                        管理
                      </Button> */}
                                <Button
                                    size="small"
                                    variant="outlined"
                                    style={{
                                        marginLeft: "55px",
                                        display: "block",
                                        marginBottom: "15px",
                                        width: "130px"
                                    }}
                                    onClick={Logout}
                                >
                サインアウト
                                </Button>
                            </CardActions>
                        </Card>
                        <PuiTooltip id={"email"}/>
                    </>
                </Modal>

      {/* 管理画面モーダル */}
      <Modal
        className={styles.editAdminModal}
        aria-labelledby="spring-modal-title"
        aria-describedby="spring-modal-description"
        open={isOpenAdminModal}
        onClose={CloseAdminModal}
        closeAfterTransition
      >
        <EditAdminPage
            key={hasAuthRoleKey}
          in={isOpenAdminModal}
          onClose={CloseAdminModal}
          isSaved={isSaved}
          setIsSaved={setIsSaved}
        />
      </Modal>

                <OnLeaveDialog
                    openDialog={openDialog}
                    handleCloseDialog={handleCloseDialog}
                    handleCancel={handleCancel}
                    handleConfirm={handleConfirm}
                />
            </>
        );
    };

    return (
    // ロゴ
        <header className={styles.header}>
            {isMobile ? (
                <>
                    <div className={styles.mobileHeaderTop}>
                        <HeaderLogo/>
                        {/* アバター */}
                        {getSearchAndAvatarComp()}
                    </div>
                    <div className={styles.mobileHeaderBottom}>
                        {getNavBtnComp()}
                        {getUserInfoAndManageComp()}
                    </div>
                </>
            )
                : (
                    <>
                        <HeaderLogo/>
                        {/* ホームページ */}
                        <div className={styles.headerRight}>
                            <div className={styles.buttons}>
                                {/* <div className={styles.divider}>
                <Divider orientation="vertical" className={classes.divider} />
              </div> */}
                                {/* Nav: Home/Presenter/Channer/Video/Search */}
                                {getNavBtnComp()}
                                {/* アバター */}
                                {getSearchAndAvatarComp()}
                                {/* user info modal & admin management modal */}
                                {userInfo? getUserInfoAndManageComp(): ""}
                            </div>
                        </div>
                    </>
                )}
        </header>
    );
}

export default Header;
